import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { get, upperFirst } from 'lodash';

import CardListItem from '@dashboard/components/CardListItem';
import TableRowElement from '@dashboard/components/TableRowElement';
import StatusBadge from '@dashboard/components/StatusBadge';
import Tooltip from '@dashboard/components/Tooltip';

import getPriceLabel from '@dashboard/services/translation/getPriceLabel';
import getChargeStatusLabel from '@dashboard/services/status/getChargeStatusLabel';

const propTypes = {
  payment: PropTypes.object.isRequired,
};

const BookingItem = ({ payment, options = {} }) => {
  const isCompact = options.appearance === 'compact';

  return (
    <CardListItem href={`/orders/bookings/${payment._id}`}>
      {!options.hideCustomer && (
        <TableRowElement size={isCompact ? 'xl' : '3xl'}>
          <div className="font-medium">
            {(payment.customer && get(payment, 'customer.email')) || '–'}
          </div>
          <div className="text-sm text-gray-500">
            {payment.customer && get(payment, 'customer.name')}
          </div>
        </TableRowElement>
      )}

      <TableRowElement size={isCompact ? 'small' : 'large'} className="font-medium">
        {getPriceLabel({
          amount: payment.amount,
          currency: payment.currency,
        })}
      </TableRowElement>

      {!options.hidePaymentLink && (
        <TableRowElement size={isCompact ? 'xl' : '4xl'}>
          {get(payment, 'page.name') || '—'}
        </TableRowElement>
      )}

      {!options.hidePageType && (
        <TableRowElement size="medium" align="right">
          {payment.page?.type ? upperFirst(payment.page?.type) : '–'}
        </TableRowElement>
      )}

      <TableRowElement size="xl" align={options.hidePageType ? 'right' : ''}>
        {format(new Date(get(payment, 'createdAt')), 'd MMM, yyyy, HH:mm')}
      </TableRowElement>

      {!options.hideStatus && (
        <TableRowElement size="medium">
          <PaymentStatusBadge
            status={payment.status}
            livemode={payment.livemode}
            error={payment.paymentError}
          />
        </TableRowElement>
      )}
    </CardListItem>
  );
};

function PaymentStatusBadge({ status, livemode, error }) {
  if (!livemode) {
    return <StatusBadge status="Test">Test</StatusBadge>;
  }

  if (error && status !== 'paid') {
    return (
      <Tooltip label={error} align="left">
        <StatusBadge status={status} label={getChargeStatusLabel(status)} withInfoIcon />
      </Tooltip>
    );
  }
  return <StatusBadge status={status} label={getChargeStatusLabel(status)} />;
}

BookingItem.propTypes = propTypes;

export default BookingItem;
